import { createAction, props } from '@ngrx/store';
import { IEditProductSolution } from '../models/product-solutions.model';

export const loadEditProductSolutions = createAction(
  '[EditProductSolution] Load EditProductSolutions',
  props<{ request: IEditProductSolution; id: string }>()
);

export const loadEditProductSolutionsSuccess = createAction(
  '[EditProductSolution] Load EditProductSolutions Success',
  props<{ response: string }>()
);

export const loadEditProductSolutionsFailure = createAction(
  '[EditProductSolution] Load EditProductSolutions Failure',
  props<{ error: Error | any }>()
);
